<script setup>
import {computed, ref, watch} from "vue";
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import Checkbox from "@/Components/Checkbox.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";
import InputError from "@/Components/InputError.vue";

const projectProperty = computed(() => usePage().props.value.project);
let project = projectProperty.value;
watch(projectProperty, (value) => {
  project = projectProperty.value;
});

const form = useForm({
  _method: 'POST',
  sample_id_val: (project.projectname || 'New sample') + ' - ' + dayjs().format('MMMM D, YYYY hh:mm A'),
  client: project.client || null,
  color: project.color || null,
  fabric: project.materialtype || null,
  detail_description: project?.purchase_order?.garmentdesc || null,
  vid: project?.vendors?.[0]?.vid || null,
  images: [],
});

const saving = ref(false);
const createSampleError = ref(null);

const projectRequiredFields = computed(() => {
  const fields = [];

  if (!form.fabric || String(form.fabric).trim() === '') {
    fields.push('Type of Material (Basic tab)');
  }

  if (!form.detail_description || String(form.detail_description).trim() === '') {
    fields.push('Garment Description (Purchase tab)');
  }

  return fields;
});

const createSample = () => {
  createSampleError.value = null;

  if (projectRequiredFields.value.length > 0) {
    createSampleError.value = `Before creating the sample, complete these project fields: ${projectRequiredFields.value.join(', ')}.`;
    return;
  }

  saving.value = true;
  let endpoint = route('admin.samples.store');

  form.post(endpoint, {
    preserveScroll: true,
    onError(errors) {
      console.error('CreateSampleStep validation errors', errors);
      const errorMessages = Object.values(errors || {}).filter(Boolean);
      createSampleError.value = errorMessages.length > 0
        ? errorMessages.join(' ')
        : 'The sample could not be created. Please review the required project fields.';
    },
    onFinish() {
      saving.value = false;
    }
  })
};

</script>

<template>
  <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
    <div v-for="(image, index) in project.image_media" :key="index" class="rounded-lg overflow-hidden shadow-lg flex flex-col items-center">
      <img :src="image.url" :alt="image.filename" class="max-w-full max-h-60 object-contain">
      <Checkbox class="mt-2 mb-2" v-model:checked="form.images" :value="image.prjimageId"/>
    </div>
  </div>
  <div class="mt-5">
    <div v-if="createSampleError" class="mb-4 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
      {{ createSampleError }}
    </div>
    <InputError :message="form.errors.detail_description" class="mb-2" />
    <InputError :message="form.errors.fabric" class="mb-2" />
    <InputError :message="form.errors.images" class="mb-2" />
    <PrimaryButton @click.prevent="createSample" :disabled="saving || form.images.length == 0">Create Sample</PrimaryButton>
  </div>
</template>
